const ISO = [
    { value: 'ES', label: 'España' },
    { value: 'PT', label: 'Portugal' }
]


export default ISO